import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './i18n'
import './index.css'
import App from './App'

const container = document.getElementById('root')!
const application = (
  <StrictMode>
    <App />
  </StrictMode>
)

const guard = document.querySelector('[data-prerender-guard]')
if (container.dataset.staticPrerender === 'true') {
  container.replaceChildren()
  window.addEventListener('esamed:route-ready', () => guard?.remove(), { once: true })
  window.setTimeout(() => guard?.remove(), 3000)
}
createRoot(container).render(application)
